import React from 'react';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
import PropTypes from 'prop-types';
import Auth from '@Services/Auth';

import SimpleTmpl from '@Services/SimpleTmpl';
import RequestUrls from '@Constants/RequestUrlsConstants';
import Button from '@Components/Button';

const getIdNumbers = (item) => {
  if (!isArray(item.registryIds)) {
    return item.registryIds;
  }

  // BE side sends not more than 100 ids in array, but result size can be greater than 100
  if (item.resultSize > 100 && item.registryIds.length >= 100) {
    return item.registryIds
      .slice(0, item.registryIds.length - 1)
      .concat('...')
      .join(', ');
  }

  return item.registryIds.join(', ');
};

const getImageUrl = (structureUrl) => {
  const token = Auth.getAccessToken();

  return SimpleTmpl.format(
    RequestUrls.relativeResultsImage.url,
    {
      imgPath: get(structureUrl, 'url'),
      accessToken: token,
    },
    true
  );
};

function BatchExecutionDetailsModalContentTable(props) {
  const { isShowPictures, detailsList, openQuery } = props;
  return (
    <div className="batch-execution-details-modal__content_table">
      <section className="table__wrapper">
        <table className="rx-table table">
          <thead className="table__head">
            <tr>
              <th scope="col" className="table__item_index">
                No.
              </th>
              {isShowPictures && (
                <th scope="col" className="table__item_structure-image">
                  Query
                </th>
              )}
              <th scope="col" className="table__item_number-of-hits">
                Number of hits
              </th>
              <th scope="col" className="table__item_rx-id">
                ID number(s):
              </th>
            </tr>
          </thead>
        </table>
      </section>
      <div className="rx-newmodal-content table__wrapper table__wrapper_content">
        <table className="rx-table table">
          <tbody className="table__content">
            {detailsList.map((detail) => {
              const updatedItemNumber = detail.itemNumber + 1;
              const key = `batch-execution-details-modal-table-${detail.queryId}`;
              return (
                <tr key={key}>
                  <td className="table__item_index">
                    {detail.resultSize && (
                      <Button
                        buttonConfig={{
                          type: 'link',
                          size: 'sm',
                          label: `${updatedItemNumber}`,
                          e2eName: key,
                        }}
                        onClick={() => openQuery(detail)}
                      />
                    )}
                    {!detail.resultSize && <span>{updatedItemNumber}</span>}
                  </td>
                  {isShowPictures && (
                    <td className="table__item_structure-image">
                      {!!detail.structureUrl && (
                        <div className="table__item_structure-image_image">
                          <img src={getImageUrl(detail.structureUrl)} alt="chemical structure" />
                        </div>
                      )}
                    </td>
                  )}
                  <td className="table__item_number-of-hits">{detail.resultSize}</td>
                  <td className="table__item_rx-id text-justify">{getIdNumbers(detail)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

BatchExecutionDetailsModalContentTable.propTypes = {
  isShowPictures: PropTypes.bool,
  detailsList: PropTypes.array,
  openQuery: PropTypes.func.isRequired,
};

export default BatchExecutionDetailsModalContentTable;
